import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const SupplierList = () => {
  const { user, setUser } = useContext(UserContext);
  const { state } = useLocation();
  const [data, setData] = useState([]);
  const [currentRequest, setCurrentRequest] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const navigate = useNavigate();
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [focusedItem, setFocusedItem] = useState(null);
  const [message,setMessage] = useState('');

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
      if (user) {
        setData(state.requests);
        setCurrentRequest(state.request);
        setCurrentItem(state.item);
        getSuppliers();
        setFocusedItem(state.focusedItem);
      }
    }
    startup();
  }, [user]);

  const getSuppliers = async () => {
    await axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getItems?item=${state.item.item._id}`, { withCredentials: true }).then((response) => {
      if (response.data.success) {
        console.log(response)
        setSuppliers(response?.data.data);
      }
    }).catch((err) => {
      const errorMessage = displayError(err,navigate,setUser);
      console.log(errorMessage);
        if(errorMessage){
          setMessage(errorMessage)
        }
    });
  };

  const assignSupplier = (supplier) => {
    data.itemRequest.forEach((request) => {
      if (request._id === currentRequest._id) {
        request.items.forEach((item) => {
          if (item.item._id === currentItem.item._id) {
            item.supplier = { id: supplier };
            request.supplierSelected = true;
          }
        });
      }
    });

    navigate("/central/home/zone", { state: { ...data, focusedItem: focusedItem } });
  };

  return (
    <>
      <div className="bg-fmb-light p-4 w-full shadow-md flex items-center mb-4">
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
        <div className="mr-4 cursor-pointer" onClick={() => navigate(-1)}>
          <span className="text-xl">←</span>
        </div>
        <div className="flex-1 flex flex-col items-center text-center">
          <h4 className="text-lg font-semibold">
            {currentItem?.item.name} - {currentItem?.quantity} {currentItem?.item.unit}
          </h4>
          <h4 className="text-sm text-black opacity-60">
            Category: {currentItem?.item.category}
          </h4>
        </div>
      </div>
      <div className="flex justify-center">
        <ul className="w-full max-w-2xl space-y-4">
          {suppliers.map((supplier, index) => (
            <li key={index} className="bg-white p-4 rounded shadow-md flex justify-between items-center mx-2">
              <div className="flex flex-col">
                <span className="font-semibold">{supplier.name}</span>
                <span className="text-sm text-gray-600">{supplier.company}</span>
                <span className="text-sm text-gray-500 mt-1">{supplier.address}</span>
              </div>
              <div className="flex items-center">
                <button
                  onClick={() => {
                    setSelectedSupplier(index);
                    assignSupplier(supplier);
                  }}
                  className={`w-6 h-6 rounded-full ${selectedSupplier === index ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                </button>
              </div>
              {selectedSupplier === index && (
                <div className="flex justify-center w-full mt-4">
                  <button className="bg-fmb text-white py-2 px-4 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:ring-opacity-50">
                    SUBMIT
                  </button>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default SupplierList;
